export default {
  TOLL_EXTERNAL_API : 1,
  REQUEST_SIMULATION_EMAIL: 2,
  TOLL_EXTERNAL_API_CONFERENCE: 3,
  QUOTATION_CSV_EXPORT: 4,
  SUPPLIER_CAN_SEE_SHIPPER_ORDER_DOCUMENTS: 5,
  FINAL_CUSTOMER_SATISFACTION_SURVEY: 6,
  FETCH_CTE_API_INTEGRATION: 7,
  ORDER_DAILY_REPORT_EMAIL_NOTIFICATION: 8,
  QUOTATION_APPROVAL_VERIFICATION: 9,
  ORDER_AWAITING_FRACTIONATION_EMAIL_NOTIFICATION: 10,
  SUPPLIER_RECEIVE_DELIVERY_DATES_NOTIFICATION: 11,
  QUOTATION_MINIMUM_TRANSPORTER_VERIFICATION: 12,
  ADDRESS_COUNTRY_OPTION: 13,
  VERIFY_IF_ORDER_IS_TRACEABLE: 14,
  BLUE_HEALTH_INTEGRATION: 15,
  QUOTATION_FREIGHT_CIF_REIMBURSEMENT_OPTION: 16,
  TRANSPORTER_ACTIVE_STATUS:17,
  PICKING: 18,
  BLUE_HEALTH_INTERNATIONAL_INTEGRATION: 19,
  FETCH_CTE_API_INTEGRATION_CREATE_FTL_IN_SP: 20,
  GENERATE_ROMANEIO: 21,
  CHATBOT: 22,
};
